import { PropsWithChildren } from 'react';
import { ExtraProps } from 'react-markdown';

const TableRenderer = ({ children }: PropsWithChildren & ExtraProps) => (
  <table className="min-w-full md:min-w-1/3 m-8 mx-auto rounded-md overflow-hidden border-separate border border-spacing-0 border-neutral-100 text-neutral-700">
    {children}
  </table>
);

const TheadRenderer = ({ children }: PropsWithChildren & ExtraProps) => <thead className="">{children}</thead>;

const ThRenderer = ({ children }: PropsWithChildren & ExtraProps) => (
  <th className="border-r border-neutral-100 last:border-r-0 border-b px-4 py-2 bg-neutral-100">{children}</th>
);

const TrRenderer = ({ children }: PropsWithChildren & ExtraProps) => <tr className="group">{children}</tr>;

const TdRenderer = ({ children }: PropsWithChildren & ExtraProps) => (
  <td className="border-r border-neutral-100 last:border-r-0 px-4 py-2 border-b group-last:border-b-0">{children}</td>
);

export { TableRenderer, TdRenderer, TheadRenderer, ThRenderer, TrRenderer };
